<script>
import GhostCar from './icons/GhostCar.vue'

export default {
  name: 'VehicleImg',
  components: {
    GhostCar
  },
  props: {
    color: {
      type: String,
      default: null
    },
    placeholderWidth: {
      type: String,
      default: '80%'
    }
  },
  data: () => ({
    hasError: false
  })
}
</script>

<template>
  <VImg
    v-bind="$attrs"
    :class="[color && `${color} lighten-5 ${color}--text`]"
    @error="hasError = true"
  >
    <template #placeholder>
      <VLazy class="layout align-center fill-height justify-center">
        <VProgressCircular
          v-if="$attrs.src && !hasError"
          indeterminate
          width="2"
          color="grey lighten-5"
        />
        <GhostCar
          v-else
          :width="placeholderWidth"
        />
      </VLazy>
    </template>
  </VImg>
</template>
